import React from 'react'
import { Box, Grid, useTheme } from '@mui/material'
import ScamAnimation from './scams/scam-animation'
import { useI18nTranslation } from '../../i18n/hook/useI18nTranslation'
import { useIsMobile } from '../../theme/useIsMobile'
import Captions from '../../frontend-lib/typhograpy/Captions'
import Suisse from '../../frontend-lib/typhograpy/Suisse'
import SangBleu from '../../frontend-lib/typhograpy/SangBleu'
import { useIsLg } from '../../theme/useIsLg'
import { useIsMd } from '../../theme/useIsMd'

const getHeader = ({ t, section }) => {
  const header = {
    home: (
      <Box
        sx={{
          py: { sm: 7, md: 10, xs: 5 },
          px: { xs: 3, lg: 16, md: 8, sm: 5 },
          maxWidth: '1500px',
        }}
      >
        <SangBleu
          size={40}
          color="grey.1"
          sx={{
            maxWidth: '1000px',
          }}
        >
          {t(`${section}.scams.title`)}
        </SangBleu>
      </Box>
    ),
    banks: (
      <Box
        sx={{
          py: { sm: 5, md: 10, xs: 5 },
          px: { xs: 3, lg: 16, md: 8, sm: 5 },
          maxWidth: '1500px',
        }}
      >
        <SangBleu
          size={40}
          color="grey.1"
          sx={{
            maxWidth: '1177px',
            mt: { xs: 3, md: 0 },
          }}
        >
          {t(`${section}.scams.title`)}
        </SangBleu>
      </Box>
    ),
    insurance: (
      <Box
        sx={{
          py: { sm: 5, md: 10, xs: 5 },
          px: { xs: 3, lg: 16, md: 10, sm: 5 },
          maxWidth: '1500px',
        }}
      >
        <SangBleu
          size={40}
          color="grey.1"
          sx={{
            maxWidth: '1177px',
            mt: { xs: 3, md: 0 },
          }}
        >
          {t(`${section}.scams.title`)}
        </SangBleu>
      </Box>
    ),
  }
  return header[section]
}
function HomeScams({ section = 'home' }) {
  const duration = 1000
  const isLg = useIsLg()
  const isMobile = useIsMobile()
  const isMd = useIsMd()
  const { t } = useI18nTranslation()
  return (
    <Box sx={{ bgcolor: 'mono.white' }}>
      <Box
        sx={{
          mb: -8,
          borderBottomWidth: { xs: '0px', sm: '0px', md: '1px' },
          borderBottomStyle: 'solid',
          borderBottomColor: 'mono.black.10',
        }}
      >
        {getHeader({ t, section })}
      </Box>
      <Grid container>
        <Grid item xs={12} sm={4} md={4} lg={5}>
          <Box
            sx={{
              maxWidth: '600px',
              pb: { xs: 6, md: 10 },
              pl: { xs: 3, sm: 5, md: 8, lg: 16 },
              pr: { lg: 2 },
            }}
          >
            <ScamAnimation
              sx={{
                ml: '60%',
                position: 'relative',
                pt: '160px',
                height: '100px',
              }}
              icon="top"
              initial={[
                {
                  translateY: 0,
                  delay: 3000,
                  duration,
                },
                {
                  translateY: -40,
                  offset: '+=2000',
                  endDelay: 1000,
                  duration,
                },
                {
                  translateY: 0,
                  duration,
                },
              ]}
              className="scam-animation-1"
            />
            <Box
              sx={{
                maxWidth: '460px',
                borderTopWidth: '1px',
                borderTopStyle: 'solid',
                borderTopColor: 'mono.black.1',
              }}
            />
            <Box
              sx={{
                bgcolor: 'mono.white',
                zIndex: 100,
                position: 'relative',
              }}
            >
              <Captions color="purple.1" size={12} sx={{ pt: 4, pb: 3 }}>
                {t(`${section}.scams.left.title`)}
              </Captions>
              <SangBleu color="purple.1" size={isMd ? 32 : 24} sx={{ pb: 4 }}>
                {t(`${section}.scams.left.subtitle`)}
              </SangBleu>
              <SangBleu color="red.2" size={56}>
                {t(`${section}.scams.left.money`)}
              </SangBleu>
              <Captions color="red.2" size={16}>
                {t(`${section}.scams.left.unit`)}
              </Captions>
              <Suisse color="red.2" size={14}>
                {t(`${section}.scams.left.description`)}
              </Suisse>
            </Box>
          </Box>
        </Grid>
        {!isMobile ? (
          <Grid
            item
            xs={8}
            sm={8}
            md={8}
            lg={7}
            sx={{ display: 'flex', flexDirection: 'row' }}
          >
            <Box sx={{ width: '70px' }}>
              <Box
                sx={{
                  paddingTop: '16%',
                  height: '100px',
                  pl: '60px',
                  position: 'absolute',
                }}
              >
                <ScamAnimation
                  icon="left"
                  initial={[
                    {
                      translateX: 0,
                      delay: 3000,
                      duration,
                    },
                    {
                      translateX: -40,
                      endDelay: 3000,
                      duration,
                    },
                    {
                      translateX: 0,
                      duration,
                    },
                  ]}
                  className="scam-animation-2"
                />
              </Box>
            </Box>
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                zIndex: 100,
                backgroundImage: `url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NzQiIGhlaWdodD0iNjMxIiB2aWV3Qm94PSIwIDAgNzc0IDYzMSIgZmlsbD0ibm9uZSI+CjxwYXRoIGQ9Ik0wIDEzNy42MDhMMzg3IDBMNzc0IDEzNy42MDhWNjMxSDBWMTM3LjYwOFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xNDc4XzI3MTM0KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzE0NzhfMjcxMzQiIHgxPSIzODciIHkxPSIxLjYzOTdlLTA1IiB4Mj0iLTQ3LjczMDgiIHkyPSI2MzguOTU1IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM2NjY1REQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDI0MTkyIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+")`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top',
                pt: 20,
              }}
            >
              <Box
                sx={{
                  pl: {
                    xl: '105px',
                    lg: '105px',
                    md: '84px',
                    sm: '40px',
                    xs: '24px',
                  },
                  pr: {
                    xl: '106px',
                    lg: '155px',
                    md: '138px',
                    sm: '64px',
                    xs: '24px',
                  },
                }}
              >
                <Box
                  sx={{
                    borderTopWidth: '1px',
                    borderTopStyle: 'solid',
                    borderTopColor: 'mono.white',
                  }}
                />
                <Captions color="mono.white" size={12} sx={{ pt: 4, pb: 3 }}>
                  {t(`${section}.scams.right.title`)}
                </Captions>
                <SangBleu
                  color="mono.white"
                  size={isMd ? 32 : 24}
                  sx={{ pb: 4 }}
                >
                  {t(`${section}.scams.right.subtitle`)}
                </SangBleu>
              </Box>
            </Box>
            {isLg && (
              <Box>
                <Box sx={{ position: 'relative', left: -95, top: 270 }}>
                  <ScamAnimation
                    icon="right"
                    initial={[
                      {
                        translateX: 0,
                        delay: 3000,
                        duration,
                      },
                      {
                        translateX: 40,
                        offset: '+=1000',
                        endDelay: 2000,
                        duration,
                      },
                      {
                        translateX: 0,
                        duration,
                      },
                    ]}
                    className="scam-animation-3"
                  />
                </Box>
              </Box>
            )}
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                zIndex: 100,
                backgroundImage: `url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NzQiIGhlaWdodD0iNjMxIiB2aWV3Qm94PSIwIDAgNzc0IDYzMSIgZmlsbD0ibm9uZSI+CjxwYXRoIGQ9Ik0wIDEzNy42MDhMMzg3IDBMNzc0IDEzNy42MDhWNjMxSDBWMTM3LjYwOFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xNDc4XzI3MTM0KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzE0NzhfMjcxMzQiIHgxPSIzODciIHkxPSIxLjYzOTdlLTA1IiB4Mj0iLTQ3LjczMDgiIHkyPSI2MzguOTU1IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM2NjY1REQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDI0MTkyIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+")`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top',
                pt: 14,
                pb: 8,
              }}
            >
              <Box
                sx={{
                  pl: {
                    xl: '105px',
                    lg: '105px',
                    md: '84px',
                    sm: '40px',
                    xs: '24px',
                  },
                  pr: {
                    xl: '106px',
                    lg: '155px',
                    md: '138px',
                    sm: '64px',
                    xs: '24px',
                  },
                }}
              >
                <Box
                  sx={{
                    borderTopWidth: '1px',
                    borderTopStyle: 'solid',
                    borderTopColor: 'mono.white',
                  }}
                />
                <Captions color="mono.white" size={12} sx={{ pt: 4, pb: 3 }}>
                  {t(`${section}.scams.right.title`)}
                </Captions>
                <SangBleu color="mono.white" size={isMd ? 32 : 24}>
                  {t(`${section}.scams.right.subtitle`)}
                </SangBleu>
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}

export default HomeScams
